<template>
	<div class="bottom_slider">
		<div class="show">
		<img class="img" src="../assets/img/anli1.jpg" alt="" />
		<img class="img" src="../assets/img/anli2.jpg" alt="" />
		<img class="img" src="../assets/img/anli3.jpg" alt="" />
		<img class="img" src="../assets/img/anli4.jpg" alt="" />
		</div>

		<p class="more_title">更多投稿案例展示</p>
		<div class="swiper-container">
			<div class="swiper-wrapper">
					<a href="#/show2" target="_blank" class="swiper-slide"><img src="../assets/img/b1.png" alt="" /></a>
					<a href="javascript:void(0);" class="swiper-slide"><img src="../assets/img/b2.png" alt="" /></a>
					<a href="javascript:void(0);" class="swiper-slide"><img src="../assets/img/b3.png" alt="" /></a>
			</div>
		</div>

	</div>
</template>

<script>
	import Swiper from 'swiper';
	export default{
		data(){
			return {

			}
		},
		
		mounted(){
			var mySwiper = new Swiper('.swiper-container', {
				effect: 'coverflow', //3d滑动
				grabCursor: true,
				centeredSlides: true,
				loop: true,
				slidesPerView: 3,
				coverflow: {
					rotate: 50,
			        stretch: 0,
			        depth: 100,
			        modifier: 1,
			        slideShadows:true,
				}
			});		

		}
	}


	
	
	
</script>

<style scoped>
	.show{
		padding-top: 241px;
		width: 1248px;
		margin: 0 auto; padding-bottom: 80px;
	}
	.show img{ display: block; margin: 0 auto; }
	.more_title{
		margin-top:0;
		font-size: 30px;
		color: #000;
		text-align: center;
		font-weight: bold;
	}

	.swiper-container {
	    width:855px;
	}
	.swiper-slide img {
	    width: 285px;
	    height: 335px;
	}
	.bottom_slider{
		margin-bottom:50px;
	}

</style>


// WEBPACK FOOTER //
// src/views/show.vue